import { getBooleanConfig, getBooleanOverride } from '@zg-rentals/frontend-config/client';
/*
 * Local JSON configs are manual snapshots of DataRouter flag values per environment.
 * They do NOT sync automatically — update the JSON files when:
 *   1. You need to test a new flag locally
 *   2. DataRouter values change and local dev should reflect the update
 */
import qaConfig from '../../config/local-frontend-config.qa.json';
import prodConfig from '../../config/local-frontend-config.prod.json';

const LOCAL_ENV = process.env.NEXT_PUBLIC_LOCAL_ENV;

const LOCAL_CONFIGS: Record<string, Record<string, boolean>> = {
  qa: qaConfig,
  prod: prodConfig,
};

function getLocalConfig(key: string): boolean | undefined {
  const config = LOCAL_ENV ? LOCAL_CONFIGS[LOCAL_ENV] : undefined;
  if (config && key in config) return Boolean(config[key]);
  return undefined;
}

/**
 * Hook for reading boolean feature flags with override support.
 *
 * Priority chain:
 * 1. URL param, then override cookie — both owned by `@zg-rentals/frontend-config` (and the rjs-ext extension)
 * 2. Local JSON config (localhost only, based on NEXT_PUBLIC_LOCAL_ENV)
 * 3. DataRouter config (QA/prod)
 * 4. Hardcoded default
 *
 * Override via query param: ?enableFeatureFlag=true or ?enableFeatureFlag=false
 * Clear one override: ?enableFeatureFlag=reset
 * Clear every override: ?fc_reset_all=true — applies on page load, not on client-side navigation
 */
export default function useBooleanConfig(key: string, defaultValue: boolean): boolean {
  // getBooleanConfig applies the same override layer internally, but overrides are read up
  // front so a local JSON snapshot can never shadow a deliberate override.
  return getBooleanOverride(key) ?? getLocalConfig(key) ?? getBooleanConfig(key, defaultValue);
}
